import { STOModel } from "../../models/base/sto-model";
import { EmployeeDocumentsSummaryDTO } from "../../models/employee-documents-summary/employee-documents-summary-dto";
import { BaseApiService } from "../base";

export class EmployeeDocumentsSummaryApiService extends BaseApiService<EmployeeDocumentsSummaryDTO, STOModel> {
  constructor() {
    super({
      servicePath: "/Employees",
      loadItemsPath: "/GetEmployeesDocumentsSummary",
    });
  }
}
